import React from "react";
import {
  Routes,
  Route,
  Navigate,
  BrowserRouter as Router,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/Login";
import ResetPwdPage from "./pages/Login/reset-pwd";
import MainLayout from "./components/Layout/MainLayout";
import StoreManagement from "./pages/master-data/store-management";
import AccountManagement from "./pages/AccountManagement";
import AccountStoreAuthPage from "./pages/AccountManagement/AccountStoreAuthPage";
import AdminStoreAuthPage from "./pages/AccountManagement/AdminStoreAuthPage";
import RoleManagement from "./pages/RoleManagement";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import ProtectedRoute from "./components/ProtectedRoute";
import NotFound from "./pages/NotFound";
import Forbidden from "./pages/Forbidden";

//订单相关页面
import OrderList from "./pages/order/order/list";
import OrderDetail from "./pages/order/order/detail";
import ReturnOrderList from "./pages/order/return-order/list";
import ShortageOrderList from "./pages/order/shortage-order/list";
import ShortageOrderDetail from "./pages/order/shortage-order/detail";
import SubstituteManagement from "./pages/order/substitute-management";

// 拣选相关页面
import PickingTaskList from "./pages/picking/picking-task";
import PickingStrategyList from "./pages/picking-strategy";

// 波次管理页面
import WaveRuleList from "./pages/wave/wave-strategy";
import WaveInstanceList from "./pages/wave/wave-instance";
import WaveConfigLogList from "./pages/wave/wave-config-log";

// 通知管理页面
import NotificationRecordList from "./pages/notification/notification-record";
import NotificationTemplateList from "./pages/notification/notification-template";

// 替代品规则管理页面
import SubstituteRuleList from "./pages/promotion-rule";

// 主数据管理页面
import ItemList from "./pages/master-data/item/list";
import CategoryList from "./pages/master-data/category/list";
import LocationList from "./pages/store-resource/location/list";

// 人员管理页面
import PersonnelManagement from "./pages/PersonnelManagement";

// 库存管理页面
import InventoryStockList from "./pages/inventory/stock/list";

// Dashboard 看板
import Dashboard from "./pages/dashboard";
import NationwideDashboard from "./pages/nationwide-dashboard";

// 报表页面
import SLAFulfillmentReport from "./pages/report/sla-fulfillment";
import PaymentInvoiceReport from "./pages/report/payment-invoice";

import "./styles/global.css";
import "./styles/App.css";

const App = () => {
  return (
    <AuthProvider>
      <Router basename="/">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/login/reset-pwd" element={<ResetPwdPage />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/403" element={<Forbidden />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="/master-data/store-management" replace />} />
            <Route path="master-data/store-management" element={<StoreManagement />} />
            
            {/* 账号管理 */}
            <Route path="account-management" element={<AccountManagement />} />
            <Route
              path="account-management/:loginId/store-auth"
              element={<AccountStoreAuthPage />}
            />
            <Route
              path="account-management/admin/store-auth"
              element={<AdminStoreAuthPage />}
            />
            <Route path="role" element={<RoleManagement />} />
            <Route path="personnel-mgt" element={<PersonnelManagement />} />
            
            {/* 用户相关 */}
            <Route path="profile" element={<Profile />} />
            <Route path="settings" element={<Settings />} />
            
            {/*订单管理 */}
            <Route path="order/order/list" element={<OrderList />} />
            <Route path="order/order/:orderNo" element={<OrderDetail />} />
            <Route path="order/return-order/list" element={<ReturnOrderList />} />
            <Route path="order/shortage-order/list" element={<ShortageOrderList />} />
            <Route path="order/shortage-order/:orderNo" element={<ShortageOrderDetail />} />
            <Route path="order/substitute-management/list" element={<SubstituteManagement />} />
            
            {/* 拣选管理 */}
            <Route path="picking/picking-task/list" element={<PickingTaskList />} />
            <Route path="picking/picking-strategy/list" element={<PickingStrategyList />} />
            
            
            {/* 波次管理 */}
            <Route path="wave/wave-strategy" element={<WaveRuleList />} />
            {/* 兼容旧路径：后端菜单 path 仍为 wave-rule 时重定向到新路径，避免 404 */}
            <Route path="wave/wave-rule" element={<Navigate to="/wave/wave-strategy" replace />} />
            <Route path="wave/wave-instance" element={<WaveInstanceList />} />
            <Route path="wave/wave-config-log" element={<WaveConfigLogList />} />

            {/* 通知管理 */}
            <Route path="notification/notification-record" element={<NotificationRecordList />} />
            <Route path="notification/notification-template" element={<NotificationTemplateList />} />

            {/* 替代品规则管理 */}
            <Route path="promotion/substitute-rule" element={<SubstituteRuleList />} />

            {/* 主数据管理 - 商品/类目/库位 */}
            <Route path="master-data/item/list" element={<ItemList />} />
            <Route path="master-data/category/list" element={<CategoryList />} />
            <Route path="master-data/location/list" element={<LocationList />} />

            {/* 库存管理 */}
            <Route path="inventory/stock/list" element={<InventoryStockList />} />

            {/* Dashboard 看板 */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="nationwide-dashboard" element={<NationwideDashboard />} />

            {/* 报表 */}
            <Route path="report/sla-fulfillment" element={<SLAFulfillmentReport />} />
            <Route path="report/payment-invoice" element={<PaymentInvoiceReport />} />
          </Route>

          {/* 404 页面 - 捕获所有未匹配的路径 */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
